export const isMobile = window.screen.width < 799 ? true : false

/**
 * Smooth scroll to a specific position
 * Uses Lenis if available, otherwise falls back to custom easing
 */
export function setSmoothScrollTo(endX, endY, duration) {
    // If Lenis is available, use it for consistent scroll behavior
    if (window.lenis) {
        window.lenis.scrollTo(endY, {
            duration: duration / 1000, // Lenis uses seconds
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        });
        return;
    }

    // Fallback: Custom smooth scroll for when Lenis is not active
    const startX = window.scrollX || window.pageXOffset;
    const startY = window.scrollY || window.pageYOffset;
    const distanceX = endX - startX;
    const distanceY = endY - startY;
    const startTime = new Date().getTime();

    duration = typeof duration !== "undefined" ? duration : 400;

    const easeInOutQuart = (time, from, distance, duration) => {
        if ((time /= duration / 2) < 1)
            return (distance / 2) * time * time * time * time + from;
        return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
    };

    const timer = setInterval(() => {
        const time = new Date().getTime() - startTime;
        const newX = easeInOutQuart(time, startX, distanceX, duration);
        const newY = easeInOutQuart(time, startY, distanceY, duration);
        if (time >= duration) {
            clearInterval(timer);
        }
        window.scroll(newX, newY);
    }, 1000 / 60);
}

/**
 * Scroll to element by ID
 * Uses Lenis if available for smooth, consistent scrolling
 */
export function anchorVerify(id){
    const element = document.getElementById(id);
    if (element) {
        // If Lenis is available, use scrollTo with element reference
        if (window.lenis) {
            window.lenis.scrollTo(element, {
                offset: 0,
                duration: 1,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            });
        } else {
            // Fallback to position-based scroll
            var targetOffset = element.offsetTop;
            setSmoothScrollTo(0, targetOffset, 1000);
        }
    } else {
        console.warn(`[anchorVerify] Element with id "${id}" not found`);
    }
}
